module.exports = __webpack_public_path__ + "img/youtube-white.3ab531df.svg";